import { useCallback, useEffect, useRef } from "react";

/**
 * Route-scoped request cancellation.
 *
 * `const nextSignal = useAbortSignal();` — each call aborts the previous
 * in-flight request from this component and returns a fresh signal; the
 * last one is aborted on unmount. Navigating away from a page therefore
 * cancels its abandoned requests instead of leaving them to pile up on
 * the server (the 2026-10-21 Sales Leads freeze), and a slow, stale
 * response can never overwrite a newer one.
 */
export default function useAbortSignal() {
  const ref = useRef(null);
  useEffect(() => () => ref.current?.abort(), []);
  return useCallback(() => {
    ref.current?.abort();
    ref.current = new AbortController();
    return ref.current.signal;
  }, []);
}
